import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useCommerceAPI } from '~/features/commerce-api/contexts';
import { StoreResponse, StoreProps } from '~/lib/data-contract/salesforce';

export const useStores = ({
    postalCode,
    countryCode = 'DK',
    count = 10,
    maxDistance = 100,
    pid,
    latitude,
    longitude,
    type,
}: StoreProps) => {
    const commerceApi = useCommerceAPI();

    return useQuery<StoreResponse | undefined, Error>({
        queryKey: ['stores', postalCode, count, maxDistance, latitude, longitude, pid, type],
        queryFn: () =>
            commerceApi.shopperStores?.getStores({
                parameters: {
                    pid,
                    postalCode,
                    countryCode,
                    count,
                    maxDistance,
                    longitude,
                    latitude,
                    type,
                },
            }),

        enabled: !!postalCode || !!(longitude && latitude),
        placeholderData: keepPreviousData,
    });
};
